<template>
  <div class="movie page">
    <van-nav-bar @click-left="toService">
      <template #title>{{ $t('video.title') }}</template>
      <template #left>
        <van-icon name="chat-o" size="26" color="#fff" />
      </template>
    </van-nav-bar>

    <van-tabs
      v-model="active"
      class="video-tabs"
      :swipe-threshold="4"
      @change="onChange"
    >
      <van-tab
        v-for="(item, index) in videolitem"
        :key="index"
        :title="item.name"
        :name="item.id"
      />
    </van-tabs>

    <div ref="scrollContainer" class="movie-list-tab fixedStyle" @scroll="handleScroll">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <ul v-if="canAccess" class="hot">
          <li v-for="(item, index) in videolist" :key="index" @click="toPlayVideo(item.id)">
            <img :src="mediaUrl(item.vod_pic)" alt="" referrerpolicy="no-referrer" loading="lazy" />
            <div class="video-meta">
              <span class="video-count">{{ $t('video.nums') }}:{{ item.count }}</span>
            </div>
          </li>
        </ul>
        <ul v-else class="hot hot-skeleton">
          <li v-for="n in 6" :key="n">
            <van-loading color="#f8f8f8" type="spinner" size="20" />
          </li>
        </ul>

        <div v-if="loading" class="status-tip">
          <van-loading size="24" type="spinner" />
        </div>
        <div v-if="!loading && finished && videolist.length === 0" class="status-tip">
          {{ $t('video.no_more') }}
        </div>
        <div v-if="finished && videolist.length > 0" class="status-tip">
          {{ $t('common.nomore') }}
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getStoredLang, pickCommaText } from '../../utils/lang'

export default {
  data() {
    return {
      active: 0,
      isLoading: false,
      count: 0,
      loading: false,
      finished: false,
      videolitem: [],
      videolist: [],
      page: 1,
    }
  },
  computed: {
    ...mapState(['userInfo', 'baseInfo']),
    canAccess() {
      return true
    },
  },
  methods: {
    handleScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      if (scrollTop + clientHeight >= scrollHeight - 50 && !this.loading && !this.finished) {
        this.loading = true
        this.getVideoList()
      }
    },
    toService() {
      const service = this.baseInfo
      if (service && service.iskefu == 1) {
        this.$router.push({ path: '/ServiceOnline' })
      } else {
        this.$router.push({ path: '/ServicePage' })
      }
    },
    parseClassName(name, lang) {
      return pickCommaText(name, lang)
    },
    mediaUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      const base = process.env.NODE_ENV === 'development' ? '' : 'https://api.t9299.top'
      return url.startsWith('/') ? `${base}${url}` : `${base}/${url}`
    },
    getVideoClass() {
      const lang = getStoredLang()
      return this.$http({ method: 'get', url: 'video_class' }).then((res) => {
        const latest = {
          id: 888,
          name: this.$t('common.all'),
        }
        const list = (res.data || []).map((item) => ({
          ...item,
          id: item.id,
          name: this.parseClassName(item.name, lang),
        }))
        this.videolitem = [latest, ...list]
        this.active = this.videolitem[0].id
      })
    },
    resetAndLoadVideos() {
      this.videolist = []
      this.page = 1
      this.count = 0
      this.finished = false
      this.loading = true
      this.getVideoList()
    },
    toPlayVideo(id) {
      if (localStorage.getItem('token')) {
        this.$router.push({ path: '/PlayVideo', query: { id } })
      } else {
        this.$router.push({ path: '/Login' })
      }
    },
    getVideoList() {
      if (!this.active) {
        this.loading = false
        return
      }
      this.$http({
        method: 'get',
        data: { id: this.active, page: this.page },
        url: 'video_list',
      })
        .then((res) => {
          if (!res || res.code !== 200) {
            this.loading = false
            this.finished = true
            return
          }
          const payload = res.data || {}
          const list = Array.isArray(payload.data)
            ? payload.data
            : Array.isArray(payload)
              ? payload
              : []
          this.videolist = this.videolist.concat(list)
          this.count = payload.count || 0
          this.page++
          this.loading = false
          if (
            list.length === 0 ||
            list.length < 12 ||
            (this.count > 0 && this.videolist.length >= this.count)
          ) {
            this.finished = true
          }
        })
        .catch(() => {
          this.loading = false
          this.finished = true
        })
    },
    onChange() {
      this.resetAndLoadVideos()
    },
    onRefresh() {
      this.resetAndLoadVideos()
      setTimeout(() => {
        this.isLoading = false
        this.$toast(this.$t('common.refresh'))
      }, 500)
    },
    initPage() {
      this.getVideoClass()
        .then(() => this.resetAndLoadVideos())
        .catch(() => {
          this.loading = false
        })
    },
    getUserInfo() {
      this.$http({ method: 'get', url: 'user_info' }).then((res) => {
        if (res.code === 200) {
          this.$store.commit('setUserInfoValue', res.data)
          if (res.data.status !== 1) {
            this.$toast(this.$t('video.account_out'))
            localStorage.clear()
            this.$router.push({ path: '/Login' })
            return
          }
          this.initPage()
        }
      })
    },
  },
  created() {
    if (localStorage.getItem('token')) {
      this.getUserInfo()
    } else {
      this.initPage()
    }
  },
}
</script>

<style lang="less" scoped>
@import '../../assets/css/base.css';

.movie {
  width: 100%;
  background: #f2f2f5;

  /deep/ .van-nav-bar {
    position: relative;
    z-index: 999;
    height: 3rem;
    line-height: 3rem;
    width: 100%;
    background-color: #df5b8d;
    background-image: url(/img/header.svg);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;

    .van-nav-bar__content {
      height: 3rem;
      align-items: center;
    }

    .van-nav-bar__title,
    .van-icon {
      color: #fff;
      font-size: 1rem;
    }

    &::after {
      border-bottom-width: 0;
    }
  }

  /deep/ .video-tabs {
    flex-shrink: 0;
    background: #fff;

    .van-tabs__wrap {
      height: 3.5rem;
    }

    .van-tabs__nav {
      background: #fff;
    }

    .van-tab {
      color: #442889;
      font-size: 1rem;
      padding: 0 0.5rem;
      line-height: 1.4;
    }

    .van-tab--active {
      font-size: 1.05rem;
      font-weight: 600;
      background-image: linear-gradient(90deg, #8e4ff1, #c571cf);
      -webkit-background-clip: text;
      background-clip: text;
      color: transparent;
    }

    .van-tabs__line {
      bottom: 0.6rem;
      width: 1.5rem;
      height: 0.2rem;
      border-radius: 0;
      background: linear-gradient(90deg, #8e4ff1, #c571cf);
    }
  }
}

.fixedStyle {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0 0.8rem 4.5rem;
  background: #f2f2f5;
  box-sizing: border-box;
}

.hot {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    width: calc(50% - 0.33333rem);
    height: 6.66667rem;
    border-radius: 0.33333rem;
    overflow: hidden;
    margin-top: 0.66667rem;
    position: relative;
    background: #e6dedb;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      display: block;
    }

    .video-meta {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.55);
      padding: 0.33333rem 0;
      display: flex;
      justify-content: space-between;
      align-items: center;
      box-sizing: border-box;
    }

    .video-title,
    .video-count {
      color: #fff;
      font-size: 0.8rem;
      width: 50%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 0 0.33333rem;
      box-sizing: border-box;
    }

    .video-count {
      text-align: right;
    }
  }

  &.hot-skeleton li {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #bdb6b3;
  }
}

.status-tip {
  text-align: center;
  padding: 0.66667rem 0 0.33333rem;
  color: #969799;
  font-size: 0.86667rem;
}
</style>
